import { gql } from '@apollo/client';

export const GET_LISTING_AVERAGE_SELLING_TIME_FOR_CAR_BODIES = gql`
  query GetListingAverageSellingTimeForCarBodies($vendorNames: [String!]!, $country: Country) {
    getListingAverageSellingTimeForCarBodies(input: { vendorNames: $vendorNames, country: $country }) {
      carBody
      sellingTimeInDays
    }
  }
`;
